import React from 'react';
interface HazardStripeProps {
  className?: string;
}
export function HazardStripe({
  className = 'h-2'
}: HazardStripeProps) {
  return <div className={`hazard-stripes w-full ${className}`} aria-hidden="true" data-id="element-101" data-mp="1f81uf46i1lz0" />;
}